import { render, staticRenderFns } from "./forumInfo.vue?vue&type=template&id=d98ee908&scoped=true"
import script from "./forumInfo.vue?vue&type=script&lang=js"
export * from "./forumInfo.vue?vue&type=script&lang=js"
import style0 from "./forumInfo.vue?vue&type=style&index=0&id=d98ee908&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d98ee908",
  null
  
)

export default component.exports